export default __webpack_public_path__ + "static/media/HT5.0b2419f6.mp4";